import React, { useEffect } from 'react';
import Home from "./pages/Home";
import { Route, Routes } from "react-router-dom";
import Explore from "./pages/Explore";
import Author from "./pages/Author";
import ItemDetails from "./pages/ItemDetails";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import AOS from 'aos';
import 'aos/dist/aos.css';
 


function App() {
  useEffect(() => {
    AOS.init({
      duration: 800, 
      easing: "ease-in-out",
      once: true,   
      useClassNames: true, 
      initClassName: false,
      animatedClassName: 'animated',
    });
  }, []);

  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id" element={<Home />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/author/:id" element={<Author />} />
        <Route path="/item-details/:id" element={<ItemDetails />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
